import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import TreeView from 'react-accessible-treeview';
import { Form } from 'react-bootstrap';

const Index = ({
  nodes,
  treeNodeHandler,
  parentNodesCount,
  selectedChildIds,
  setSelectedChildIds,
  treeIndex
}) => {
  const [selectedParentNodes, setSelectedParentNodes] = useState([]);
  const [selectedParentIds, setSelectedParentIds] = useState([]);
  const [isExpand, setIsExpand] = useState(false);
  const [flatTree, setFlatTree] = useState([]);

  useEffect(() => {
    updateToFlatTree(nodes[0], setFlatTree);
  }, []);

  const updateToFlatTree = (node, setTree) => {
    if (node?.childrens?.length) {
      setTree((prevData) => [
        ...prevData,
        ...node.childrens.map((child) => ({
          ...child,
          parentId: node.id,
        })),
      ]);

      node.childrens.forEach((child) => {
        updateToFlatTree(child, setTree);
      });
    }
  };

  const handleMainParentClick = (nodeId, index) => {
    if (!selectedParentNodes.some((node) => node?.id === nodeId)) {
      let newNode = { id: nodeId };
      let newSelectedNodes = [...selectedParentNodes];
      newSelectedNodes = Array.from({ length: parentNodesCount }, (_, i) => ({
        id: i < selectedParentNodes.length ? selectedParentNodes[i].id : ''
      }));
      newSelectedNodes[index] = { id: newNode.id };
      setSelectedParentNodes(newSelectedNodes);
    } else {
      setSelectedParentNodes((prevNodes) =>
        prevNodes.map((item, i) => ({
          id: i === index ? '' : item.id
        }))
      );
    }
    setIsExpand(!isExpand);
  };

  const handleChildClick = (rootName, nodeValue, isExpanded, isChildAvailable, childrens) => {
    if (!isExpanded) treeNodeHandler(rootName, nodeValue, isChildAvailable, childrens, treeIndex);
  };

  const handleMainNodeSelection = (seletedChild, childNodes) => {
    const directChilds = seletedChild.childrens.filter(item => !item.isBranch).map(item => item.id);
    const allDirectChildsSelected = directChilds.every(id => childNodes.includes(id));
    return allDirectChildsSelected;
  };

  const handleChildParentSelection = (nodeId, childs, directChilds, checkBranch = false) => {
    const seletedChild = flatTree.find(item => item.id == nodeId);
    if (seletedChild) {
      let directChildsChecked = true;
      if (nodeId == nodes[0].id) {
        directChildsChecked = handleMainNodeSelection(nodes[0], directChilds);
      }

      let allChildNodes = flatTree
        .filter((item) => item.parentId == seletedChild.parentId &&
          (!checkBranch || (item.isBranch && item.id != nodes[0].id))).map((item1) => item1.id);

      const allSelected = allChildNodes.every(id => childs.includes(id));
      const parentNodes = checkBranch ? [...childs] : [...selectedParentIds];

      let updatedNodes = [];
      if ((allSelected && (nodeId == nodes[0].id ? directChildsChecked : true)))
        updatedNodes = Array.from(new Set([...parentNodes, seletedChild.parentId]));
      else
        updatedNodes = parentNodes.filter((item) => item != seletedChild.parentId);
      setSelectedParentIds(updatedNodes);

      if (seletedChild.parent)
        handleChildParentSelection(seletedChild.parentId, updatedNodes, directChilds, true);
    }
  };

  const handleChildCheckboxSelect = (event) => {
    const nodeId = event.target.id;
    const treeNode = selectedChildIds;
    if (event.target.checked) {
      const selectedNode = treeNode.find((item) => item == nodeId);
      if (!selectedNode) {
        const updatedTreeNodes = [...treeNode, nodeId];
        const childs = updatedTreeNodes.map(item => item);
        handleChildParentSelection(nodeId, childs, childs);
        setSelectedChildIds(childs);
      }
    } else {
      const childs = treeNode.filter((item) => item !== nodeId);
      handleChildParentSelection(nodeId, childs, childs);
      setSelectedChildIds(childs);
    }
  };

  const handleParentCheckBoxSelect = (nodeId, checked) => {
    const selectedNode = nodes[0].id == nodeId ? nodes[0] : flatTree.find(item => item.id == nodeId);
    let childIds = getAllChildIds(selectedNode);
    const parentIds = getAllParentIds(selectedNode);

    const updatedChildIds = addRemoveIds(childIds, checked, selectedChildIds, setSelectedChildIds);
    const updatedParentIds = addRemoveIds(parentIds, checked, selectedParentIds, setSelectedParentIds);

    handleHighlevelParents(nodeId, updatedParentIds, updatedChildIds);
  };

  const getAllChildIds = (node) => {
    let childNodes = [];
    const collectChildren = (node) => {
      if (node?.childrens?.length) {
        node.childrens.forEach((child) => {
          childNodes.push(child.id);
          collectChildren(child);
        });
      }
    };
    collectChildren(node);
    return childNodes;
  };

  const getAllParentIds = (node) => {
    let ids = [];
    if (node.childrens?.length && node.isBranch) {
      ids.push(node.id);
      node.childrens.forEach((child) => {
        ids = ids.concat(getAllParentIds(child));
      });
    }
    return ids;
  };

  const addRemoveIds = (ids, checked, selectedIds, setIds) => {
    let filteredIds = [];
    if (checked)
      filteredIds = Array.from(new Set([...selectedIds, ...ids]));
    else
      filteredIds = selectedIds.filter((obj) => !ids.includes(obj));
    setIds(filteredIds);
    return filteredIds;
  };

  const handleHighlevelParents = (nodeId, parentNodes, childNodes) => {
    const seletedChild = flatTree.find(item => item.id == nodeId);
    let directChildsChecked = true;
    if (nodeId == nodes[0].id)
      directChildsChecked = handleMainNodeSelection(nodes[0], childNodes);

    const allChildNodes = flatTree.filter((item) => item.parentId == seletedChild.parentId && item.isBranch && item.id != nodes[0].id).map(item1 => item1.id);
    const allSelected = allChildNodes.every(id => parentNodes.includes(id));

    let updatedNodes = [];
    if ((allSelected && (nodeId == nodes[0].id ? directChildsChecked : true)))
      updatedNodes = Array.from(new Set([...parentNodes, seletedChild.parentId]));
    else
      updatedNodes = parentNodes.filter((item) => item != seletedChild.parentId);

    setSelectedParentIds(updatedNodes);
    handleHighlevelParents(seletedChild.parentId, updatedNodes, childNodes);
  };

  return (
    <>
      {nodes.map((item, index) => {
        return (
          <div
            key={index}
            className={`assignments-card col-4 cursor-pointer w-100 ${index % 3 === 0 ? 'clear-row' : ''}`}>
            <div className="select-questions p-1">
              <div
                id={item.name}
                className="d-flex align-items-center">
                <div className="align-items-center d-flex tree-icon-div justify-content-center m-2"
                  onClick={() => handleMainParentClick(item.name, index)}>
                  <FontAwesomeIcon
                    icon={
                      selectedParentNodes.find((node) => node.id === item.name) ? faMinus : faPlus
                    }
                    className="tree-icon"
                  />
                </div>
                <Form.Check
                  type="checkbox"
                  checked={(selectedParentIds.filter((obj) => obj == item.id)).length > 0}
                  className="checkbox-name mr-1"
                  onChange={(e) => handleParentCheckBoxSelect(item.id, e.target.checked)}
                />
                <div>{item.name}</div>
              </div>
              {selectedParentNodes.find((node) => node.id === item.name) && (
                <>
                  <TreeView
                    key={`tree${index}`}
                    data={item.childrens}
                    aria-label="Checkbox tree"
                    multiSelect
                    propagateSelect
                    propagateSelectUpwards
                    togglableSelect
                    nodeRenderer={({
                      element,
                      isBranch,
                      isExpanded,
                      getNodeProps,
                      handleExpand
                    }) => {
                      return (
                        <>
                          <div>
                            {isBranch && (
                              <>
                                <div>
                                  <div className='d-flex'>
                                    <div className="tree-icon-div mb-2 margin-left-20"
                                      onClick={() =>
                                        handleChildClick(item.name, element.id, isExpanded, element.isChildAvailable, element.childrens)
                                      }>
                                      <div {...getNodeProps({ onClick: handleExpand })}>
                                        <FontAwesomeIcon
                                          icon={isExpanded ? faMinus : faPlus}
                                          className="tree-icon"
                                          isOpen={isExpanded}
                                          
                                        />
                                      </div>
                                    </div>
                                    <Form.Check
                                      type="checkbox"
                                      checked={(selectedParentIds.filter((obj) => obj == element.id)).length > 0}
                                      className="checkbox-name"
                                      onChange={(e) => handleParentCheckBoxSelect(element.id, e.target.checked)}
                                    />
                                    <span id={element.id} className="inkto m-2 mb-1 mt-0">
                                      {element.name}
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}
                            {!isBranch && (
                              <div className="d-flex">
                                <Form.Check
                                  id={element.id}
                                  type="checkbox"
                                  className="checkbox-name margin-left-20"
                                  onChange={(e) => {
                                    handleChildCheckboxSelect(e);
                                    e.stopPropagation();
                                  }}
                                  value={element.name}
                                  checked={(selectedChildIds.filter((obj) => obj == element.id)).length > 0}
                                />
                                <span
                                  id={element.id}
                                  className="linkto m-2 mb-1 mt-0">
                                  {element.name}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                </>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

Index.propTypes = {
  nodes: PropTypes.array,
  treeNodeHandler: PropTypes.func,
  parentNodesCount: PropTypes.number,
  selectedAllNodes: PropTypes.array,
  setSelectedAllNodes: PropTypes.func,
  setSelectedNodes: PropTypes.func,
  treeIndex: PropTypes.number,
  selectedChildIds: PropTypes.array,
  setSelectedChildIds: PropTypes.func
};

export default Index;
